import React, { useMemo } from "react";
import CampaignListing from "components/CampaignListing";
import CampaignCard from "components/CampaignCard";

const Topics = ({ countriesCampaigns }) => {
  const countries = useMemo(() => Object.entries(countriesCampaigns), [countriesCampaigns]);
  return countries.map(([country, campaigns]) => (
    <div className="country-campaigns-list" key={country}>
      <CampaignListing isNarrow headingText={country}>
        {campaigns.data.map((campaign, i) => (
          <CampaignCard key={`${i}-${campaign.id}}`} campaign={campaign} />
        ))}
      </CampaignListing>
    </div>
  ));
};

export default Topics;
